var map = {
	"./placeholder.png": "603f",
	"./review-fail.png": "9e8e",
	"./review-success.png": "3dfc",
	"./review-waitting.png": "5b83",
	"./steps-first.png": "a7b4",
	"./submitted.png": "2fc2",
	"./warning.png": "5606"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "8aaa";